export function getBackendBasePath(): string {
    if (process.env.NODE_ENV === 'development') {
        return 'http://localhost:5050';
    }

    return '';
}
